<div class="container">
    <div class="row">
      <div class="col-12 mb-5">
        <app-toolkit-page-title title="Modifica atto di finanziamento">
          <div ngbDropdown class="d-inline-block">
            <button
              type="button"
              class="btn btn-outline-primary mt-3 mr-2"
              ngbDropdownToggle
              id="azioni"
            >
              Azioni
              <app-toolkit-bl-icon
                icon="arrow-down-triangle"
                cssClass="icon icon-sm icon-primary"
              ></app-toolkit-bl-icon>
            </button>
            <div ngbDropdownMenu aria-labelledby="azioni">
              <button ngbDropdownItem [routerLink]="['../ricerca']">
                <app-toolkit-bl-icon
                  icon="arrow-left"
                  cssClass="icon icon-sm icon-secondary"
                ></app-toolkit-bl-icon>
                Torna indietro
              </button>
            </div>
          </div>
        </app-toolkit-page-title>
        <div class="steppers">
          <app-toolkit-anagrafica-tab-anagrafica-legge
            [formGroup]="criteriaForm"
          ></app-toolkit-anagrafica-tab-anagrafica-legge>
          <nav class="text-right">
            <button
              type="button"
              class="btn btn-primary steppers-btn-confirm"
              (click)="modificaLegge()"
            >
              {{ "Conferma" }}
            </button>
          </nav>
        </div>
      </div>
    </div>
  </div>
  